module.exports = __webpack_public_path__ + "img/tool_orange.e2aa748e.svg";